import { render, staticRenderFns } from "./AppCommissionRow.vue?vue&type=template&id=61b54e19&scoped=true&"
import script from "./AppCommissionRow.vue?vue&type=script&lang=js&"
export * from "./AppCommissionRow.vue?vue&type=script&lang=js&"
import style0 from "./AppCommissionRow.vue?vue&type=style&index=0&id=61b54e19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b54e19",
  null
  
)

export default component.exports